import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import choiceMbCn from '../assets/faq/choice_mb_chinese.png';
import choiceMbEn from '../assets/faq/choice_mb_en.png';
import choicePcCn from '../assets/faq/choice_pc_chinese.png';
import choicePcEn from '../assets/faq/choice_pc_en.png';
import { type IChoice } from '../interfaces';

import 'react-lazy-load-image-component/src/effects/blur.css';

export const Choice = ({ t, isChinese }: IChoice): JSX.Element => {
  const animationDuration = 300;
  const initialQuestionsObj = { q1: false };
  const [questionsObj, setQuestionsObj] =
    useState<Record<string, boolean>>(initialQuestionsObj);

  const handleQuestionsObj = (question: string): void => {
    if (!questionsObj[question]) {
      setQuestionsObj({ ...initialQuestionsObj, [question]: true });
      const element = document.getElementById('c1');
      if (element != null) {
        setTimeout(() => { element.scrollIntoView(true); }, animationDuration);
      }
    } else {
      setQuestionsObj({ ...initialQuestionsObj });
    }
  };

  const iconStyle = { color: 'white', height: '48px', width: '48px' };

  return (
    <div className="choice-container">
      <div className={`choice-q1-container ${questionsObj.q1 ? 'back-shadow' : ''}`}>
        <button id="c1" onClick={() => { handleQuestionsObj('q1'); }}>
          <div className={`label-container ${questionsObj.q1 ? 'no-border' : ''}`}>
            <strong>{`1. ${t('qChoice1')}`}</strong>
            {questionsObj.q1
              ? <KeyboardArrowDownIcon sx={iconStyle} />
              : <KeyboardArrowUpIcon sx={iconStyle} />}
          </div>
        </button>
        <AnimateHeight duration={animationDuration} height={questionsObj.q1 ? 'auto' : 0}>
          <section>
            <p>{t('faqChoice1')}</p>
            <div className="choice-images">
              <LazyLoadImage
                src={isChinese ? choiceMbCn : choiceMbEn}
                alt="CHOICE mobile"
                width="350px"
                height="auto"
                effect="blur"
              />
              <LazyLoadImage
                src={isChinese ? choicePcCn : choicePcEn}
                alt="CHOICE desktop"
                width="700px"
                height="auto"
                effect="blur"
              />
            </div>
          </section>
        </AnimateHeight>
      </div>
    </div>
  );
};
